import * as React from 'react';
import { Link } from 'gatsby';
import Layout from '../components/Layout';
import SEO from '../components/SEO';

const NotFoundPage = () => (
  <Layout>
    <div
      className="container landing"
      style={{ marginTop: '50px', marginBottom: '200px' }}
    >
      <h1>Not found :(</h1>
      <Link to="/">To front page</Link>
    </div>
  </Layout>
);

export const Head = () => (
  <SEO
    title="Not found :("
    description="Oops! Page not found. The content you're looking for might have been moved or deleted. Please check the URL or navigate back to the homepage."
  ></SEO>
);

export default NotFoundPage;
